import { request } from './index'
import { HTTP_METHODS } from './const'

const getLoyaltyUser = () =>
  request({
    url: `v7/customers/loyalty`,
    method: HTTP_METHODS.get,
  })

export default getLoyaltyUser
